/* eslint-disable import/prefer-default-export */
import moment from 'moment';
import 'moment-timezone';
import i18n from './i18n';

export const formatDate = (dateString: Date, format = DateFormat.DD_MMM_YYYY) => (
  moment(dateString).locale(i18n.language).tz(DateFormat.JAKARTA_TZ).format(format)
);

export const formatDateDDMMMM = (dateString: Date) => (
  formatDate(dateString, DateFormat.DD_MMMM)
);

export const parseDate = (dateString: string, keepLocalTime?: boolean) => moment(
  dateString,
).tz(DateFormat.JAKARTA_TZ, keepLocalTime).toDate();

export const isISO8601Format = (dateString: string) => {
  const m = moment(dateString, moment.ISO_8601, true);
  return m.isValid();
};

export const diffDuration = (
  startDate: Date,
  endDate: Date,
) => moment.duration(moment(startDate).diff(moment(endDate)));

export const getCurrentTime = () => moment();

export const getTimeByTimeZone = (
  time: string,
  timezone = DateFormat.JAKARTA_TZ,
  format = DateFormat.HOUR_MM_FORMAT,
) => moment.tz(time, format, timezone);

export const isBetweenHours = (currentTime = getCurrentTime()) => {
  const startTime = getTimeByTimeZone('7:00 am');
  const endTime = getTimeByTimeZone('11:00 pm');
  return currentTime.isBetween(startTime, endTime, 'minutes', '[]');
};

export const stringDateToISO = (dateString: Date) => (dateString ? new Date(dateString).toISOString() : '');

export const getDaysInBetween = (startDateISO: Date = new Date(), endDateISO: Date = new Date()) => Math.abs(moment(endDateISO).diff(moment(startDateISO), 'days'));

export const getDaysInBetweenRoundUp = (startDateISO: Date = new Date(), endDateISO: Date = new Date()) => Math.ceil(moment(endDateISO).diff(moment(startDateISO), 'days', true));

export const isDateEqual = (firstDate: Date, secondDate: Date): boolean => moment(firstDate).diff(secondDate, 'days') === 0;

export const DateFormat = {
  DEFAULT: '',
  MMMM_YYYY: 'MMMM YYYY', // April 2021
  MMM_YYYY: 'MMM YYYY', // Apr 2021
  D_MMM: 'D MMM', // 1 Apr
  DD_MMM_YYYY: 'DD MMM YYYY', // 01 Apr 2021
  D_MMM_YYYY: 'D MMM YYYY', // 1 Apr 2021
  D_MMM_H_MM_A: 'D MMM, h:mm A', // 1 Apr, 03:33 am
  DD_MMMM: 'DD MMMM', // 31 April
  MMMM: 'MMMM', // April
  JAKARTA_TZ: 'Asia/Jakarta',
  HOUR_MM_FORMAT: 'h:mm a', // 7:00 am
  HOUR_MM_A: 'h:mm A', // 7:00 AM
  DD_MMM: 'DD MMM', // 31 Apr
  DDDD_E_MMM_YYYY_HH_MM: 'dddd, DD MMM YYYY, HH:mm', // Friday, 28 Aug 2020, 12:28
  DDDD_E_MMM_YYYY_HH_MM_A: 'dddd, DD MMM YYYY, h:mm A', // Friday, 28 Aug 2020, 12:28 PM
  DD_MMM_YYYY_H_MM_A: 'DD MMM YYYY, h:mm A', // 28 Aug 2020, 11:28 AM
  DD_MMM_YYYY_H_MM: 'DD MMM YYYY, HH:mm', // 28 Aug 2020, 12:03
  MMM: 'MMM', // Apr,
  DDMMYYYY: 'DDMMYYYY', // 25072022
};
